import { render, staticRenderFns } from "./StudyHome.vue?vue&type=template&id=2470face&scoped=true&"
import script from "./StudyHome.vue?vue&type=script&lang=ts&"
export * from "./StudyHome.vue?vue&type=script&lang=ts&"
import style0 from "./StudyHome.vue?vue&type=style&index=0&id=2470face&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470face",
  null
  
)

export default component.exports